import { render, staticRenderFns } from "./BlogItem.vue?vue&type=template&id=02ea53cf&scoped=true"
import script from "./BlogItem.vue?vue&type=script&lang=js"
export * from "./BlogItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ea53cf",
  null
  
)

export default component.exports